/**
 * Client-side gate for the bulk-unbillable import. This is a UX speed bump only --
 * the real access control is the backend admin-role check; the secret ships in the
 * JS bundle. It currently matches TEMP_PASSWORD_FOR_COHORTS by value; kept as its
 * own constant so this flow can rotate independently if needed.
 */
export const BULK_UNBILLABLE_PASSWORD = 'opnjhaJZBLo4';
